import React from 'react';

const SectionHeader = ({ title, actionLabel, onAction }) => {
  return (
    <div className="flex items-center justify-between mb-4 md:mb-6">
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground">{title}</h2>
      {actionLabel ? (
        <button
          type="button"
          onClick={onAction}
          className="px-4 py-2 rounded-md bg-muted/40 text-foreground hover:bg-muted transition-gaming"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
};

export default SectionHeader;
